import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "location"

  connect() {
    super.connect()

    // Guard: una sola request por montaje del controller
    if (this.element.dataset.locationRequested === "true") return
    this.element.dataset.locationRequested = "true"

    this.send("request_location", {}, async (response) => {
      const { latitude, longitude, changed, success } = response.data

      // Permiso denegado
      if (success === false || changed === undefined) {
        if (!localStorage.getItem("location_denied")) {
          localStorage.setItem("location_denied", "1")
        }
        return
      }

      localStorage.removeItem("location_denied")
      document.cookie = `last_location=${latitude}&${longitude}; path=/; max-age=31536000`

      // Si no cambió Y ya teníamos cookie, no hay nada que refrescar
      const hadCookie = document.cookie.includes("last_location=")
      if (!changed && hadCookie) return

      // Update via Turbo Stream — sin navegación, sin reload
      const url = `/stores?latitude=${latitude}&longitude=${longitude}`
      const res = await fetch(url, {
        headers: { Accept: "text/vnd.turbo-stream.html" }
      })

      if (res.ok) {
        Turbo.renderStreamMessage(await res.text())
      }
    })
  }

  disconnect() {
    // Reset para que al re-montar (navegación dentro de la app) vuelva a pedir
    delete this.element.dataset.locationRequested
    super.disconnect()
  }
}



